module.exports = __webpack_public_path__ + "img/how-to_image02.44c57687.png";